import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@4.6.4_3ce3f796c6cc3a17c8a263c2a1a625c4/node_modules/nuxt/dist/pages/runtime/validate.js";
import domain_45routing_45global from "/opt/build/repo/apps/act/middleware/domain-routing.global.ts";
import forms_45optin_45global from "/opt/build/repo/apps/act/middleware/forms-optin.global.ts";
import legacy_45query_45global from "/opt/build/repo/apps/act/middleware/legacy-query.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@4.6.4_3ce3f796c6cc3a17c8a263c2a1a625c4/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  domain_45routing_45global,
  forms_45optin_45global,
  legacy_45query_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/build/repo/apps/act/middleware/auth.ts")
}